(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@wallaby-ui/core", [], factory);
	else if(typeof exports === 'object')
		exports["@wallaby-ui/core"] = factory();
	else
		root["@wallaby-ui/core"] = factory();
})(self, () => {
return 